"use client";
import * as React from "react";
import dynamic from "next/dynamic";

/**
 * TODO Next移行後に削除する
 * @returns
 */
const ReactRouterPage = () => {
  const App = dynamic(() => import("../../src/app").then(({ App }) => App), {
    ssr: false,
  });

  return <App />;
};

export default ReactRouterPage;
